"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordAssociationState = (_class = /*#__PURE__*/function (_RootState) {
  function WordAssociationState(wordAssociation) {
    var _this;
    _classCallCheck(this, WordAssociationState);
    _this = _callSuper(this, WordAssociationState);
    _initializerDefineProperty(_this, "submittedValue", _descriptor, _this);
    _initializerDefineProperty(_this, "submittedWordAssociation", _descriptor2, _this);
    _initializerDefineProperty(_this, "blankValueFilledIn", _descriptor3, _this);
    _initializerDefineProperty(_this, "assigned", _descriptor4, _this);
    _initializerDefineProperty(_this, "incorrectCasing", _descriptor5, _this);
    _initializerDefineProperty(_this, "incorrectSpecialCharacters", _descriptor6, _this);
    _initializerDefineProperty(_this, "incorrectPunctuation", _descriptor7, _this);
    _initializerDefineProperty(_this, "exercise", _descriptor8, _this);
    _this.submittedValueMatchesAlternateText = function () {
      var match = _this.bestMatchingTarget;
      return (0, _utils.isPresent)(match) && match !== _this.normalizedAdjustedTargetText;
    };
    _this.wordAssociation = wordAssociation;
    return _this;
  }
  _inherits(WordAssociationState, _RootState);
  return _createClass(WordAssociationState, [{
    key: "correct",
    get: function get() {
      return !this.blankValueFilledIn && this.submittedValue && this.submittedValueMatches;
    }
  }, {
    key: "normalizedAdjustedTargetText",
    get: function get() {
      if ((0, _utils.isPresent)(this.exercise)) {
        return (0, _utils.normalizeCharacters)(this.wordAssociation.adjustedTargetTextForExercise(this.exercise));
      }
      return (0, _utils.normalizeCharacters)(this.wordAssociation.adjustedTargetText);
    }
  }, {
    key: "normalizedSubmittedValue",
    get: function get() {
      if ((0, _lodash.isString)(this.submittedValue)) {
        return (0, _utils.normalizeCharacters)(this.submittedValue);
      }
    }
  }, {
    key: "alternateTexts",
    get: function get() {
      var _this$wordAssociation, _this$wordAssociation2;
      return (_this$wordAssociation = (_this$wordAssociation2 = this.wordAssociation.alternateText) === null || _this$wordAssociation2 === void 0 ? void 0 : _this$wordAssociation2.split(',')) !== null && _this$wordAssociation !== void 0 ? _this$wordAssociation : [];
    }
  }, {
    key: "bestMatchingTarget",
    get: function get() {
      var _this2 = this;
      if (!(0, _lodash.isString)(this.normalizedSubmittedValue)) return null;
      var mainTarget = this.normalizedAdjustedTargetText;
      var normalizedAlternates = this.alternateTexts.map(function (t) {
        return (0, _utils.normalizeCharacters)(t);
      });
      var allTargets = [mainTarget].concat(_toConsumableArray(normalizedAlternates));
      var strictMatch = allTargets.find(function (t) {
        return t === _this2.normalizedSubmittedValue;
      });
      if (strictMatch) return strictMatch;
      var looseMatch = allTargets.find(function (t) {
        return (0, _utils.sameWithoutCaseAccentsAndPunctuation)(_this2.normalizedSubmittedValue, t);
      });
      return looseMatch || null;
    }
  }, {
    key: "submittedValueMatches",
    get: function get() {
      if ((0, _lodash.isString)(this.normalizedSubmittedValue) && (0, _lodash.isString)(this.normalizedAdjustedTargetText)) {
        return (0, _utils.isPresent)(this.bestMatchingTarget);
      }
      if ((0, _lodash.isBoolean)(this.submittedValue)) {
        return this.submittedValue === this.wordAssociation.selected;
      }
      return false;
    }
  }, {
    key: "hasSubmittedValue",
    get: function get() {
      return (0, _utils.isPresent)(this.submittedValue);
    }
  }, {
    key: "entryHasUserInput",
    get: function get() {
      return !this.blankValueFilledIn && (this.submittedValue !== null || (0, _utils.isPresent)(this.submittedWordAssociation));
    }
  }, {
    key: "evaluate",
    value: function evaluate(params, exercise) {
      this.exercise = exercise;
      if ((0, _utils.isPresent)(this.submittedValue) && (0, _lodash.isString)(this.submittedValue) && (0, _utils.isPresent)(this.wordAssociation.adjustedTargetText)) {
        var targetToCompare = this.bestMatchingTarget || this.normalizedAdjustedTargetText;
        var allowLowercaseFirstLetter = (exercise === null || exercise === void 0 ? void 0 : exercise.capitalizeEntries) === false && this.wordAssociation.firstInSentence;
        var submittedValueToCompare = allowLowercaseFirstLetter ? (0, _lodash.lowerFirst)(this.normalizedSubmittedValue) : this.normalizedSubmittedValue;
        var targetValueToCompare = allowLowercaseFirstLetter ? (0, _lodash.lowerFirst)(targetToCompare) : targetToCompare;
        var _compareSubmittedValu = (0, _utils.compareSubmittedValueWithSolution)(submittedValueToCompare, targetValueToCompare),
          incorrectCasing = _compareSubmittedValu.incorrectCasing,
          incorrectSpecialCharacters = _compareSubmittedValu.incorrectSpecialCharacters,
          incorrectPunctuation = _compareSubmittedValu.incorrectPunctuation;
        this.incorrectCasing = incorrectCasing;
        this.incorrectSpecialCharacters = incorrectSpecialCharacters;
        this.incorrectPunctuation = incorrectPunctuation;
      }
      if ((0, _utils.isBlank)(this.submittedValue)) {
        this.submittedValue = this.wordAssociation.adjustedTargetText;
        this.submittedWordAssociation = {};
        this.blankValueFilledIn = true;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.submittedValue = null;
      this.submittedWordAssociation = {};
      this.blankValueFilledIn = false;
      this.assigned = false;
      this.incorrectCasing = false;
      this.incorrectSpecialCharacters = false;
      this.incorrectPunctuation = false;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "submittedValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "submittedWordAssociation", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "blankValueFilledIn", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "assigned", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "incorrectCasing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "incorrectSpecialCharacters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "incorrectPunctuation", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "correct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "correct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "normalizedAdjustedTargetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedAdjustedTargetText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "normalizedSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedSubmittedValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alternateTexts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "alternateTexts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bestMatchingTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bestMatchingTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submittedValueMatches", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submittedValueMatches"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSubmittedValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "entryHasUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "entryHasUserInput"), _class.prototype), _class);
var _default = exports["default"] = WordAssociationState;